var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoHoraeWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 277.64 57.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.88,2.76c-8.7,0-15.3,3.24-20.34,8.16-5.76,5.52-8.28,12.12-8.28,19.02s2.52,13.56,8.28,19.02c5.04,4.86,11.7,8.16,20.34,8.16s15.18-3.3,20.34-8.16c5.82-5.52,8.28-12.12,8.28-19.02s-2.52-13.56-8.28-19.08c-5.1-4.8-11.7-8.1-20.34-8.1ZM83.88,44.52v-14.55h-14.64s0-.02,0-.03c0-6.9,5.22-14.58,14.64-14.58s14.64,7.74,14.64,14.58-5.28,14.58-14.64,14.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M165.18,21.54c0-8.22-6.6-18.78-19.92-18.78h-26.04v54.36h13.92V15.36h12.12c3.48,0,6,3.18,6,6.18s-2.46,6.3-6,6.3c-3.18,0-6.42-.06-9.6-.12h-2.28l17.58,29.4h15.72l-11.34-19.26c6.72-3.72,9.84-10.38,9.84-16.32Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "172.4 57.12 187.76 57.12 202.4 29.1 216.92 57.12 232.34 57.12 201.92 0 172.4 57.12"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 237.74,
    y: 23.7,
    width: 33.9,
    height: 12.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 237.74,
    y: 44.52,
    width: 39.9,
    height: 12.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 237.74,
    y: 2.76,
    width: 39.9,
    height: 12.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "34.62 23.64 13.92 23.64 13.92 2.76 0 2.76 0 23.64 0 57.12 13.92 57.12 13.92 36.24 34.62 36.24 34.62 57.12 48.54 57.12 48.54 23.64 48.54 12.76 34.62 12.76 34.62 23.64"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHoraeWhite);
export default __webpack_public_path__ + "static/media/logo-horae-white.dc53fbe365208d7df14ba5c056b87572.svg";
export { ForwardRef as ReactComponent };